import $ from "jquery";

$("body").on("click tap", "[data-open-overlay]", function () {
    let type = $(this).attr("data-open-overlay");
    let externalLink = $(this).attr("data-overlay-external-link");
    let externalLinkText = $(this).attr("data-overlay-external-link-text");

    $("#overlay").attr("data-overlay-type", type);
    $("#overlay").attr(
        "data-overlay-external-link",
        externalLink ? externalLink : ""
    );
    $("#overlay").attr(
        "data-overlay-external-link-text",
        externalLinkText ? externalLinkText : ""
    );

    if (type == "video") {
        let videoID = $(this).attr("data-overlay-video-id");
        let videoType = $(this).attr("data-overlay-video-type");
        let videoRatio = $(this).attr("data-overlay-video-ratio");
        console.debug(videoID);
        console.debug(videoType);
        console.debug(videoRatio);
        $("#overlay").attr("data-overlay-video-id", videoID);
        $("#overlay").attr("data-overlay-video-type", videoType);
        $("#overlay").attr("data-overlay-video-ratio", videoRatio);
    }

    if (type == "image") {
        let image = $(this).attr("data-overlay-image");
        $("#overlay").attr("data-overlay-image", image);
    }
    if (type == "iframe") {
        let iframe = $(this).attr("data-overlay-iframe");
        $("#overlay").attr("data-overlay-iframe", iframe);
    }

    $("#overlay").foundation("open");
});

$("[data-modal-overlay]").on("open.zf.reveal", function () {
    let type = $(this).attr("data-overlay-type");
    let externalLink = $(this).attr("data-overlay-external-link");
    let externalLinkText = $(this).attr("data-overlay-external-link-text");
    let videoID = $(this).attr("data-overlay-video-id");
    let videoType = $(this).attr("data-overlay-video-type");
    let videoRatio = $(this).attr("data-overlay-video-ratio");
    let image = $(this).attr("data-overlay-image");
    let iframe = $(this).attr("data-overlay-iframe");

    if (externalLink) {
        $("#overlay-btn-external").attr("href", externalLink);
        $("#overlay-btn-external-text").text(externalLinkText);
        $("#overlay-btn-external").removeClass("s_hidden");
    } else {
        $("#overlay-btn-external").addClass("s_hidden");
    }

    if (!externalLink) {
        $("#overlay-bottom-bar").addClass("s_hidden");
    } else {
        $("#overlay-bottom-bar").removeClass("s_hidden");
    }

    if (type == "video") {
        let youtube = `<div class="responsive-embed ${videoRatio}"><iframe width="560" height="315" src="https://www.youtube.com/embed/${videoID}?rel=0&autoplay=1" frameborder="0" gesture="media" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
        let vimeo = `<div class="responsive-embed ${videoRatio}"><iframe src="https://player.vimeo.com/video/${videoID}?byline=0&portrait=0&autoplay=1&loop=1&autopause=0" width="640" height="274" frameborder="0" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>`;

        if (videoType == "youtube") {
            $("#overlay-content").html(youtube);
        }
        if (videoType == "vimeo") {
            $("#overlay-content").html(vimeo);
        }
    }
    if (type == "image") {
        $("#overlay-content").html(`<img src="${image}" alt="" />`);
    }
    if (type == "iframe") {
        $("#overlay-content").html(
            `<div class="sb_overlay_iframe"><iframe src="${iframe}" frameborder="0" width="100%" height="100%" /></div>`
        );
    }
});

$("[data-modal-overlay]").on("closed.zf.reveal", function () {
    $(this).find(".sb_overlay_content").html("");
});
